export default function SaveSearchIco({ color }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.1437 0.833252C15.5856 0.833252 16.0096 1.00884 16.3221 1.32141L18.6791 3.67843C18.9917 3.99099 19.1673 4.41491 19.1673 4.85694V16.6666C19.1673 18.0473 18.0481 19.1666 16.6673 19.1666H3.33398C1.95328 19.1666 0.833984 18.0473 0.833984 16.6666V3.33325C0.833984 1.95254 1.95328 0.833252 3.33398 0.833252H15.1437ZM3.33398 2.49992C2.87375 2.49992 2.50065 2.87302 2.50065 3.33325V16.6666C2.50065 17.1268 2.87375 17.4999 3.33398 17.4999H4.16732V12.4999C4.16732 11.1192 5.28661 9.99992 6.66732 9.99992H13.334C14.7147 9.99992 15.834 11.1192 15.834 12.4999V17.4999H16.6673C17.1276 17.4999 17.5006 17.1268 17.5006 16.6666V5.69028C17.5006 5.24824 17.3251 4.82433 17.0125 4.51176L15.4888 2.98808C15.1762 2.67551 14.7523 2.49992 14.3103 2.49992H14.1673V4.16658C14.1673 5.54729 13.0481 6.66658 11.6673 6.66658H8.33398C6.95328 6.66658 5.83398 5.54729 5.83398 4.16658V2.49992H3.33398ZM14.1673 17.4999V12.4999C14.1673 12.0397 13.7942 11.6666 13.334 11.6666H6.66732C6.20708 11.6666 5.83398 12.0397 5.83398 12.4999V17.4999H14.1673ZM7.50065 2.49992H12.5007V4.16658C12.5007 4.62682 12.1276 4.99992 11.6673 4.99992H8.33398C7.87375 4.99992 7.50065 4.62682 7.50065 4.16658V2.49992Z"
        fill={color || "white"}
      />
    </svg>
  );
}
